module.exports = __webpack_public_path__ + "assets/img/office-details-garage-icon.45eb5b80.svg";